import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-col links-col">
          <Link to="/about" onClick={toTop}>
            About Us
          </Link>
          <Link to="/shipping" onClick={toTop}>
            Shipping
          </Link>
          <Link to="/returns" onClick={toTop}>
            Returns
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Cookies
          </Link>
          <Link to="/faqs" onClick={toTop}>
            FAQs
          </Link>
          <Link to="/terms" onClick={toTop}>
            Terms
          </Link>
        </div>

        <div className="footer-col contact-col">
          <h4 className="col-title">Contact Us</h4>
          <p>Email: send@isanroute.space</p>
          <p>9 Essex St East, Temple Bar, Dublin D02RW53, Ireland</p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <span className="copyright">© 2026 - isanroute</span>
        </div>
        <div className="footer-bottom-right payment-icons" aria-label="Supported payment methods">
          <span className="payment-badge">VISA</span>
          <span className="payment-badge">Mastercard</span>
          <span className="payment-badge">AMEX</span>
          <span className="payment-badge">Discover</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
